export const CSS_SECONDARY_BUTTON_GROUP =
  '!tw-h-16 md:!tw-h-14 tw-relative !tw-font-semibold !tw-text-sm !tw-p-0'
